import React from 'react'
import MaterialSymbol from '../material-symbol'

const AddCircleOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="add_circle_outline" {...props} />
))

AddCircleOutline.displayName = 'AddCircleOutline'

export default AddCircleOutline
